import React, { useState } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import { withRouter } from 'react-router-dom'
import ShareIcon from './share-icon'
import { ShareModal } from '../../../../share/share'

const styles = ({ COLORS, FONT_SIZES, BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 20px 0 0',
    listStyle: 'none',
    padding: '0',
    '& > li': {
      marginLeft: '1em'
    }
  },
  shareCaret: {
    marginLeft: '.6em'
  },
  share: {
    background: 'var(--yellow)',
    borderColor: 'var(--dark-blue)',
    color: 'var(--dark-blue)',
    '&:hover': {
      background: 'var(--yellow-)',
      borderColor: 'var(--dark-blue-)'
    }
  }
})

const LPMenu = ({
  classes,
  match,
  presentationTitle,
  presentationLo,
  premiumRestricted,
  pending,
  presentation
}) => {
  const [showShareModal, setShowShareModal] = useState(false)

  return (
    <>
      <ul className={`${classes.container} metrics__share-buttons`}>
        {pending ? null : (
          <li>
            <Button
              minw
              className={classes.share}
              action={() => {
                setShowShareModal(true)
              }}
              icon={<ShareIcon />}
              tall>
              Share
            </Button>
          </li>
        )}
      </ul>
      {presentation && (
        <ShareModal
          from="builder"
          userIsOwner
          presentation={presentation}
          isOpen={showShareModal}
          requestClose={() => setShowShareModal(false)}
        />
      )}
    </>
  )
}

export default withRouter(injectSheet(styles)(LPMenu))
